//#region src/dom/bindForwardedRef.ts
const bindForwardedRef = (ref, node) => {
	if (node && ref) {
		if (typeof ref === "function") ref(node);
		else ref.current = node;
	}
};
//#endregion
export { bindForwardedRef };
